


interface ILocalStore {
  // locationStore: LocationStore;
  // authStore: AuthStore;
}

const LocalStore: ILocalStore = {
  // locationStore: new LocationStore(),
  // authStore: new AuthStore(),
};

export { ILocalStore, LocalStore };
